import isEmpty from 'lodash/isEmpty';

const join = (rules) => (value, data, params) =>
  rules.map((rule) => rule(value, data, params)).filter((error) => !!error)[0];

export function email(value: string): 'Invalid email address' | undefined {
  // Let's not start a debate on email regex. This is just for an example app!
  if (
    !isEmpty(value) &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
  ) {
    return 'Invalid email address';
  }
}

export function required(value): boolean {
  return isEmpty(value);
}

export function minLength(value: string | any[], min: number): boolean {
  if (!isEmpty(value) && value.length < min) {
    return false;
  }
  return true;
}

export function maxLength(
  max: number
): (value: string | any[]) => string | undefined {
  return (value: string | any[]): string | undefined => {
    if (!isEmpty(value) && value.length > max) {
      return `Must be no more than ${max} characters`;
    }
  };
}

export function integer(value: any): 'Must be an integer' | undefined {
  if (!isEmpty(value) && !Number.isInteger(Number(value))) {
    return 'Must be an integer';
  }
}

export function oneOf(enumeration: any[]): (value: any) => string | undefined {
  return (value: any): string | undefined => {
    if (!enumeration.includes(value)) {
      return `Must be one of: ${enumeration.join(', ')}`;
    }
  };
}

export function match(
  field: string
): (value: any, data: any) => string | undefined {
  return (value, data): string | undefined => {
    if (data && value !== data[field]) {
      return 'Do not match';
    }
  };
}

export function createValidator(rules, params): (data: any) => any {
  return (data = {}) => {
    const errors = {};
    Object.keys(rules).forEach((key) => {
      const rule = join([].concat(rules[key])); // concat enables both functions and arrays of functions
      const error = rule(data[key], data, { key, ...params });
      if (error) {
        errors[key] = error;
      }
    });
    return errors;
  };
}

export const isURL = (urlString) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};
